import './index.css';

import Box, { BoxProps } from '@mui/material/Box';
import React from 'react';

import LottiePlayer from 'components/LottiePlayer';
import animationData from 'assets/lotties/cardriving.json';

export interface UnplugAnimationProps extends BoxProps { }

const UnplugAnimation: React.FC<UnplugAnimationProps> = React.memo((props) => {
    return (
        <React.Fragment>
            <Box
                {...props}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                className="unplug-animation-container"
            >
                <LottiePlayer loop={true} animationData={animationData} />
            </Box>
        </React.Fragment>
    );
});

export default React.memo(UnplugAnimation);
